module.exports = __webpack_public_path__ + "static/media/focoaortico.ddc48f77.jpg";